<div class="logo-placeholder" [style.--logo-size]="size + 'px'">
	@if (logoSrc) {
		<img
			#assigneeLogo
			[src]="logoSrc"
			class="logo"
			(error)="
				assigneeLogo.src = fallbackSrc; assigneeLogo.classList.add('placeholder-icon')
			"
			alt="organization logo"
		/>
	} @else {
		<mat-icon [svgIcon]="noLogoSvgIcon" class="no-logo-icon"></mat-icon>
	}
</div>
